<template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>DEPARTMENTS</h2>
				</div>
				<v-btn @click.prevent="fncDepartmentAdd" class="elevation-5" color="info"><i class="material-icons">add</i>Create Department</v-btn>
				<v-btn @click.prevent="fncReloadDepartments" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {
			}
		},
		methods: {
          fncDepartmentAdd() {
            this.$store.commit( 'setDepartmentLoader', true );
              this.$store.dispatch('fncPopulateUserRegions');
              this.$store.dispatch('fncBranchRanges', 'add');
              var modalDetails = { title: 'Add Department', component: 'modal-department-add', mstate: true, params: {} };
              this.$store.commit({
                type: 'setModal',
                details: modalDetails
              });
          },
          fncReloadDepartments() {
            this.$store.commit('fncEmptyDepartments');
            this.$store.dispatch({
              type: 'fncPopulateDepartments',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([
				'objAuthorize'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
